import styled from "styled-components/macro";

import { colors, space } from "shared/styles/constants";
import { Button } from "shared/components/Button";

export const PagerContainer = styled.ul`
  display: flex;

  list-style: none;
  padding: 0;

  li + li {
    margin-left: ${space.xxs};
  }
`;

const pagerButtonSize = space.xl;

export const StyledPagerButton = styled(Button)`
  min-width: ${pagerButtonSize};
  min-height: ${pagerButtonSize};
`;

export const PagerDots = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;

  height: 100%;
  padding: ${space.xs};

  color: ${colors.grey3};
  letter-spacing: 1px;

  min-width: ${pagerButtonSize};
  min-height: ${pagerButtonSize};
`;
